import React, { useState } from "react";
import "./styles.css";
import { faqList } from "../../../Mobile/Pages/MobileFAQ/faqData";

const IMG_BASE = 'https://focus-training.oss-accelerate.aliyuncs.com/cisc/mobile/fqa';

export default function ViewFAQ() {
  const [openMap, setOpenMap] = useState({});

  const toggleItem = (index) => {
    setOpenMap((prev) => ({ ...prev, [index]: !prev[index] }));
  };

  return (
    <div className="PCViewFAQ">
      {/* 板块左上角装饰图 */}
      <img className="pcTL" src={`${IMG_BASE}/pcTL.png`} alt="" />
      <img className="pcBL" src={`${IMG_BASE}/pcBL.png`} alt="" />
      <img className="pcBR" src={`${IMG_BASE}/pcBR.png`} alt="" />
      <div className="faqContent">
        {/* 标题区：标题 + 标题装饰图 */}
        <div className="faqtitleview">
          <div className="titlefaq">常见问题</div>
          <div className="faqtitleimgdiv">
            <img className="faqtitleimg" src={`${IMG_BASE}/pcfqatitle.png`} alt="" />
          </div>
        </div>

        <div className="faqList">
          {faqList.map((item, index) => {
            const isOpen = !!openMap[index];
            return (
              <div className={isOpen ? 'faqItem faqItemOpen' : 'faqItem'} key={index}>
                <div className="faqQuestionRow" onClick={() => toggleItem(index)}>
                  <img className="faqCornerTL" src={`${IMG_BASE}/jiaobiaozuoshang.png`} alt="" />
                  <div className="faqQuestion">
                    <div className="faqQuestionCN">{item.qCN}</div>
                    <div className="faqQuestionEN">{item.qEN}</div>
                  </div>
                  <img
                    className={isOpen ? 'faqArrow faqArrowUp' : 'faqArrow faqArrowDown'}
                    src={`${IMG_BASE}/jiantou.png`}
                    alt=""
                  />
                  <img className="faqCornerBR" src={`${IMG_BASE}/fqawenzi.png`} alt="" />
                </div>

                <div className="faqItemSeperatLine"></div>

                {isOpen && (
                  <div className="faqAnswerBox">
                    <div className="faqTextCN">{item.aCN}</div>
                    <div className="faqTextEN">{item.aEN}</div>
                    <img className="faqAnswerBottomBG" src={`${IMG_BASE}/pcbgzhankai.png`} alt="" />
                  </div>
                )}

                {isOpen && <div className="faqItemSeperatLine"></div>}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
